import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { DevExpressModule } from '../../devexpress.module';
import { SharedModule } from '../../shared/shared.module';

import { SelfDiagnosticRoutingModule } from './self-diagnostic-routing.module';

import { SearchServiceComponent } from './pages/search-service/search-service.component';
import { SelfDiagnosticStepComponent } from './pages/self-diagnostic-step/self-diagnostic-step.component';
import { RateComponent } from './pages/rate/rate.component';
import { ServiceCatalogComponent } from './pages/service-catalog/service-catalog.component';

@NgModule({
  imports: [CommonModule, TranslateModule, SelfDiagnosticRoutingModule, SharedModule, DevExpressModule],
  declarations: [SearchServiceComponent, SelfDiagnosticStepComponent, RateComponent, ServiceCatalogComponent],
})
export class SelfDiagnosticModule {}
